import React from 'react';
import './Home.css';
import Navbar from './Navbar';

function Home() {
  return (
    <div>
      <Navbar />
      <div className="home-container">
        <div className="image-section">
          <img src="https://th.bing.com/th/id/OIP.kB8S6DDZsVhvLlqU4FOwEAHaEU?pid=ImgDet&rs=1" alt="Profile" />
        </div>
        <div className="text-section">
          <h1>Hi, I am Shiva</h1>
          <p>Innovative problem solver with a passion for data structures and algorithms, showcasing expertise through impactful machine learning and deep learning projects. Proficient in crafting captivating full-stack websites using React JS, developing native mobile apps, and creating compelling designs with HTML. Adept in big data analytics, ROS, and renowned for exceptional communication and leadership prowess.</p>
         
        </div>
      </div>
    </div>
  );
}

export default Home;
